
import Vue from "vue";
import Component from "vue-class-component";
import InputForm from "@/components/base/form/InputForm.vue";
import { Getter, State, Action } from "vuex-class";
import { FormConfig, FormValid } from "@/config";
import { deepClone } from "@/common/utils";
@Component({
	name: "UnitExtraBasic",
	components: { InputForm }
})
export default class UnitExtraBasic extends Vue {
	@State("basic") private basic: any;
	@Getter("id") private id: any;
	@Getter("save") private isSave: any;
	@Getter("roleSave") private isAuthern: any;
	@Getter("company") private company: any;
	@Getter("unitId") private unitId: any;
	@Action("account/getAuthernData") private getAuthern: any;
	@Action("account/getExtraInfo") private getBasic: any;
	@Action("account/addCenterExtraInfo") private addBasic: any;
	@Action("account/getBasic") private getBasicData: any;
	$https: any;
	isEdit = false;
	formName: any = "CompanyBaseInfo";
	currentPage = 0;
	labelWidth: any = "200px";
	labelPosition: any = "top";
	btnData = "额外信息";
	// btnData = [
	//   "基本信息", "财务信息", "附件信息",
	// ];
	socialIdCard: any = this.$store.state.account.socialIdCard;
	input = "";
	rules: any = {
		unitName: [
			{
				required: true,
				trigger: "blur",
				message: "请输入企业名称"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入企业名称"
			}
		],
		organizationType: [
			{
				required: true,
				trigger: "blur",
				message: "请选择企业类型"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择企业类型"
			}
		],
		registeredAddress: [
			{
				required: true,
				trigger: "blur",
				message: "请输入注册地址"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入注册地址"
			}
		],
		theirIndustry: [
			{
				required: true,
				trigger: "blur",
				message: "请选择所属行业"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择所属行业"
			}
		],
		dusinessAddress: [
			{
				required: true,
				trigger: "blur",
				message: "请输入经营地址"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入经营地址"
			}
		],
		detailedAddress: [
			{
				required: true,
				trigger: "blur",
				message: "请输入详细地址"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入详细地址"
			}
		],
		workArea: [
			{
				required: true,
				trigger: "blur",
				message: "请输入办公面积"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入办公面积"
			},
			{ validator: FormValid.number }
		],
		monthlyRent: [
			{
				required: true,
				trigger: "blur",
				message: "请输入月租金"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入月租金"
			},
			{ validator: FormValid.number }
		],
		numberCompanies: [
			{
				required: true,
				trigger: "blur",
				message: "请输入企业人数"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入企业人数"
			},
			{ validator: FormValid.number }
		],
		undergraduateNumber: [
			{
				required: true,
				trigger: "blur",
				message: "请输入本科以上学历人数"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入本科以上学历人数"
			},
			{ validator: FormValid.number }
		],
		patentNumber: [
			{
				required: true,
				trigger: "blur",
				message: "请输入发明专利"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入发明专利"
			},
			{ validator: FormValid.number }
		],
		newInventionPatent: [
			{
				required: true,
				trigger: "blur",
				message: "请输入新型发明专利"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入新型发明专利"
			},
			{ validator: FormValid.number }
		],
		softwareCopyright: [
			{
				required: true,
				trigger: "blur",
				message: "请输入软件著作权"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入软件著作权"
			},
			{ validator: FormValid.number }
		],
		officeBuildingProperties: [
			{
				required: true,
				trigger: "blur",
				message: "请选择办公楼属性(选框不明)"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择办公楼属性(选框不明)"
			}
		],
		annualTurnover: [
			{
				required: true,
				trigger: "blur",
				message: "请输入年营业额"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入年营业额"
			},
			{ validator: FormValid.number }
		],
		rdexpenses: [
			{
				required: true,
				trigger: "blur",
				message: "请输入研发费用"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入研发费用"
			},
			{ validator: FormValid.number }
		],
		iurActivities: [
			{
				required: true,
				trigger: "blur",
				message: "请选择产学研活动"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择产学研活动"
			}
		],
		registeredCapital: [
			{
				required: false,
				trigger: "blur",
				message: "请输入注册资本"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入注册资本"
			},
			{ validator: FormValid.number }
		],
		foreignCapitalPercentage: [
			{
				required: false,
				trigger: "blur",
				message: "请输入注册资金以及外资(包含港澳台)占比"
			},
			// {
			//     "required": false,
			//     "trigger": "change",
			//     "message": "请输入注册资金以及外资(包含港澳台)占比"
			// },
			{ validator: FormValid.floatFloor1 }
		],
		whetherFinance: [
			{
				required: false,
				trigger: "blur",
				message: "请输入是否融资"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入是否融资"
			}
		],
		enterpriseOwnershi: [
			{
				required: false,
				trigger: "blur",
				message: "请选择企业归属(可复选)"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择企业归属(可复选)"
			}
		],
		industryDirection: [
			{
				required: false,
				trigger: "blur",
				message: "请选择产品(服务)所属产业方向(可复选)"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择产品(服务)所属产业方向(可复选)"
			}
		],
		productName: [
			{
				required: false,
				trigger: "blur",
				message: "请输入产品名称"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入产品名称"
			}
		],
		productDescription: [
			{
				required: false,
				trigger: "blur",
				message: "请输入产品介绍"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入产品介绍"
			}
		],
		highTechIndustry: [
			{
				required: false,
				trigger: "blur",
				message: "请选择国家高新技术企业"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择国家高新技术企业"
			}
		],
		recognitionTime: [
			{
				required: false,
				trigger: "blur",
				message: "请输入认定时间"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入认定时间"
			}
		],
		serialNumber: [
			{
				required: false,
				trigger: "blur",
				message: "请输入编号"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入编号"
			}
		],
		smeCertification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择自治区科技型中小企业认定"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择自治区科技型中小企业认定"
			}
		],
		littleCertification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择市级科技小巨人认定"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择市级科技小巨人认定"
			}
		],
		smallMicroCertification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择市级科技型小微企业认定"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择市级科技型小微企业认定"
			}
		],
		iso9000Certification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择通过ISO9000质量体系认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择通过ISO9000质量体系认证"
			}
		],
		iso14000Certification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择通过ISO14000质量体系认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择通过ISO14000质量体系认证"
			}
		],
		ohsas18000Certification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择通过OHSAS18000职业健康安全体系认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择通过OHSAS18000职业健康安全体系认证"
			}
		],
		otherCertifications: [
			{
				required: false,
				trigger: "blur",
				message: "请选择其他认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择其他认证"
			}
		]
	};
	formData: any = {};
	setting: any = [
		{
			label: "企业名称",
			ref: "unitName",
			type: "input",
			span: 12,
			disabled: false,
			required: true
		},
		{
			label: "企业类型",
			type: "cascader",
			ref: "organizationType",
			options: FormConfig.unit_type,
			span: 12,
			disabled: false,
			required: true
		},
		{
			label: "注册地址",
			ref: "registeredAddress",
			span: 12,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "所属行业",
			ref: "theirIndustry",
			span: 12,
			options: FormConfig.industry,
			type: "cascader",
			disabled: true,
			required: true
		},
		{
			label: "详细地址",
			ref: "detailedAddress",
			span: 12,
			type: "input",
			disabled: true,
			required: true
		},
		{
			label: "经营地址",
			ref: "dusinessAddress",
			span: 12,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "办公面积",
			ref: "workArea",
			span: 12,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "月租金",
			ref: "monthlyRent",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "企业人数",
			ref: "numberCompanies",
			span: 12,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "本科以上学历人数",
			ref: "undergraduateNumber",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "发明专利",
			ref: "patentNumber",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "新型发明专利",
			ref: "newInventionPatent",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "软件著作权",
			ref: "softwareCopyright",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "办公楼属性(选框不明)",
			ref: "officeBuildingProperties",
			span: 12,
			options: FormConfig.industry,
			type: "cascader",
			disabled: false,
			required: true
		},
		{
			label: "年营业额",
			ref: "annualTurnover",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "研发费用",
			ref: "rdexpenses",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: true
		},
		{
			label: "产学研活动",
			ref: "iurActivities",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: true
		},
		{
			label: "注册资本",
			ref: "registeredCapital",
			span: 12,
			disabled: false,
			type: "input",
			required: false
		},
		{
			label: "注册资金以及外资(包含港澳台)占比",
			ref: "foreignCapitalPercentage",
			span: 12,
			type: "input",
			disabled: false,
			required: false
		},
		{
			label: "是否融资",
			ref: "whetherFinance",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "企业归属(可复选)",
			ref: "enterpriseOwnershi",
			span: 12,
			options: FormConfig.enterpriseOwnershi,
			props: { multiple: true },
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "产品(服务)所属产业方向(可复选)",
			ref: "industryDirection",
			span: 12,
			options: FormConfig.industryDirection,
			props: { multiple: true },
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "产品名称",
			ref: "productName",
			span: 12,
			type: "input",
			disabled: false,
			required: false
		},
		{
			label: "产品介绍",
			ref: "productDescription",
			span: 12,
			type: "input",
			disabled: false,
			required: false
		},
		{
			label: "国家高新技术企业",
			ref: "highTechIndustry",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "认定时间",
			ref: "recognitionTime",
			span: 12,
			type: "time",
			disabled: false,
			required: false
		},
		{
			label: "编号",
			ref: "serialNumber",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: false
		},
		{
			label: "自治区科技型中小企业认定",
			ref: "smeCertification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "市级科技小巨人认定",
			ref: "littleCertification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "市级科技型小微企业认定",
			ref: "smallMicroCertification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "通过ISO9000质量体系认证",
			ref: "iso9000Certification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "通过ISO14000质量体系认证",
			ref: "iso14000Certification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "通过OHSAS18000职业健康安全体系认证",
			ref: "ohsas18000Certification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		},
		{
			label: "其他认证",
			ref: "otherCertifications",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false
		}
	];
	state = 0;
	edit() {
		this.isEdit = true;
		this.setting.forEach((el: any) => {
			if (this.isAuthern !== 1) {
				el.type = "input";
			} else {
				if (el.ref !== "cName" && el.ref !== "socialIdCard") {
					el.type = "input";
				}
			}
		});
	}
	created() {
		this.getSaveData();

		// if(this.isSave === 1) {
		//   this.setStatus();
		// }
	}
	setStatus() {
		this.isEdit = false;
		this.setting.forEach((el: any) => {
			el.type = "text";
		});
	}
	async getSaveData() {
		if (!this.company || this.isAuthern !== 1 || !this.isAuthern) {
			this.$message.warning("请先进行实名认证");
			return;
		}
		const {
			unitRegisteredAddress: registeredAddress,
			legalNumber: socialIdCard,
			unitName
		} = await this.getAuthern();
		const {
			data: { unitCode }
		} = await this.getBasicData();
		const { detailedAddress, organizationType, theirIndustry } = unitCode;
		this.getBasic({ unitName: this.company }).then(
			({ code, data, msg }: any) => {
				if (code === 0) {
					this.setting.map((item: any) => {
						let disList = [
							"socialIdCard",
							"unitName",
							"organizationType",
							"registeredAddress"
						];
						if (disList.includes(item.ref)) {
							item.disabled = true;
						}
						return item;
					});
					const savedData = data[0];
					const properties = {
						registeredAddress,
						unitName,
						organizationType,
						detailedAddress,
						theirIndustry,
						...savedData
					};
					const cascaderList = [
						"enterpriseOwnershi",
						"industryDirection",
						"organizationType",
						"theirIndustry",
						"officeBuildingProperties",
						"iurActivities",
						"highTechIndustry",
						"smeCertification",
						"littleCertification",
						"smallMicroCertification",
						"iso9000Certification",
						"iso14000Certification",
						"ohsas18000Certification",
						"otherCertifications",
						"whetherFinance"
					];
					for (let property in properties) {
						if (cascaderList.includes(property)) {
							if (typeof properties[property] === "string") {
								properties[property] =
									properties[property].indexOf(",") >= 0
										? properties[property].split(",")
										: [properties[property]];
							} else if (properties[property]) {
								properties[property] = [properties[property]];
							} else if (properties[property] === 0) {
								properties[property] = [0];
							} else {
								properties[property] = [];
							}
						}
					}
					this.formData = { ...properties };
					return data;
				}
			}
		);
	}
	async submit() {
		const state = await (this.$refs.companyBaseInfo as any).validFormReturn();
		if (!state) {
			// this.$message.warning("请正确填写表单")
			return false;
		}
		return true;
	}
	async save() {
		const cascaderList = [
			"enterpriseOwnershi",
			"industryDirection",
			"organizationType",
			"theirIndustry",
			"officeBuildingProperties",
			"iurActivities",
			"highTechIndustry",
			"smeCertification",
			"littleCertification",
			"smallMicroCertification",
			"iso9000Certification",
			"iso14000Certification",
			"ohsas18000Certification",
			"otherCertifications",
			"whetherFinance"
		];
		const state = await (this.$refs.companyBaseInfo as any).validFormReturn();
		if (!state) {
			// return this.$message.warning("请正确填写表单")
			return;
		}
		let properties = deepClone(this.formData);
		delete properties.setting;
		for (let property in properties) {
			if (cascaderList.includes(property)) {
				properties[property] = properties[property].join(",");
			}
		}
		// this.$refs.companyBaseInfo.validator() {}
		const options = {
			id: this.unitId,
			...properties
		};
		this.addBasic(options).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.$message.success("提交成功");
				return data;
			}
		});
	}
	// save(type: any) {
	//   switch (type) {
	//   case 0: this.addBasicData();break;
	//   case 1: this.addBasicData();break;
	//   case 2: this.addBasicData();break;
	//   default: break;
	//   }
	// }
}
